import { computed } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import useTlmCart from '@/composable/useTlmCart';
import useCartScenarios from '~/composable/useCartScenarios';
import useProductType from '~/composable/useProductType';
import { useUserInQuarantineStore } from '~/stores/useUserInQuarantineStore';

function isTruthyScenarioFlag (value) {
  return value === true || value === 'true'
}

export default function useUserInQuarantine (app) {
  const userInQuarantineStore = useUserInQuarantineStore()
  const { fullPriceMOProratedPrice, fullPriceSubscriptionName } = storeToRefs(userInQuarantineStore)
  const { subscriptionList, cart } = useTlmCart(app);
  const { isMobileBroadBandSubscription } = useProductType();
  const { setScenario, getScenario, cartScenarios } = useCartScenarios(app);
  // Hydrate reactive store from localStorage so CartContent sees existing quarantine flag
  getScenario()

  const setFullPriceSubscriptionDetails = (validationResponse) => {
    const fullPriceSubscription = validationResponse?.responseObject?.productList?.find(product =>
      product.addedByValidation && product.causedByProduct.value === subscriptionList.value.sku)
    fullPriceMOProratedPrice.value = fullPriceSubscription?.proratedPrice.value
    fullPriceSubscriptionName.value = fullPriceSubscription?.shortName
  }

  const subscription = computed(() => {
    return subscriptionList.value.cartProduct.additionalBillingInformation
  })

  /**
   * Reactive to cartScenarios (updated by setScenario).
   * True if ANY group for this cart has userInQuarantine — avoids multi-group
   * false overwriting true (MBB + router).
   */
  const isUserInQuarantine = computed(() => {
    const scenarios = cartScenarios.value
    const cartId = cart.value?.id
    if (!cartId || !scenarios?.[cartId]) {
      return false
    }
    return Object.values(scenarios[cartId]).some(groupScenario =>
      isTruthyScenarioFlag(groupScenario?.userInQuarantine)
    )
  })

  const setUserInQuarantine = () => {
    setScenario(cart.value, 'userInQuarantine', true)
    getScenario()
    userInQuarantineStore.isUserInQuarantine = true
  }

  return {
    fullPriceSubscriptionName,
    fullPriceMOProratedPrice,
    setFullPriceSubscriptionDetails,
    setUserInQuarantine,
    isMobileBroadBandSubscription: computed(() => isMobileBroadBandSubscription(subscriptionList.value.cartProduct.productTypeKey)),
    isUserInQuarantine,
    subscription
  }
}
